// BI数据缓存
export const BIcacheData = {
  BIdepartmentQuality: 'BIdepartmentQuality', // 部门获客质量
  BIemployeeQuality: 'BIemployeeQuality', // 员工获客质量
  BIchannelQuality: 'BIchannelQuality', // 渠道获客质量-按渠道
  BIchannelQualityClass: 'BIchannelQualityClass', // 按分类

  BIdepartmentCosts: 'BIdepartmentCosts', // 部门获客成本
  BIemployeeCosts: 'BIemployeeCosts', // 员工获客成本
  BIchannelCosts: 'BIchannelCosts', // 渠道获客成本
  BIcityCosts: 'BIcityCosts', // 城市获客成本
  BIhighseasCosts: 'BIhighseasCosts', // 公海获客成本

  BIallocationStatistics: 'BIallocationStatistics', // 员工分派

  collisionReminderCost: 'collisionReminderCost', // 撞库提醒成本
  collisionReminderCount: 'collisionReminderCount' // 撞库提醒统计
}

export const BIcacheJobData = {
  BIjobAnalysisTrend: 'BIjobAnalysisTrend', // 通话数据分析-趋势
  BIjobAnalysisDetail: 'BIjobAnalysisDetail' // 通话数据分析-明细
}
